import { render, staticRenderFns } from "./SampleRequestModal.vue?vue&type=template&id=1f0ef35a&scoped=true&lang=pug"
import script from "./SampleRequestModal.vue?vue&type=script&lang=js"
export * from "./SampleRequestModal.vue?vue&type=script&lang=js"
import style0 from "./SampleRequestModal.vue?vue&type=style&index=0&id=1f0ef35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ef35a",
  null
  
)

export default component.exports